<template>
    <modal id="lockout-modal" :class="{ 'is-active': isOpen }" :onClose="negativeAction">
        <header slot="header" class="modal-card-head has-text-centered">
            <p class="modal-card-title">{{ 'components.common.modals.lockout.title' | translate }}</p>
            <button class="delete" aria-label="close" @click="negativeAction"></button>
        </header>
        <section slot="content" class="modal-card-body">
            <p class="title is-4 has-text-centered">{{ 'components.common.modals.lockout.confirmation message' | translate }}</p>
            <div class="field has-text-centered">
                <button slot="footer" class="button is-danger is-medium" @click="positiveAction">
                    {{ 'components.common.modals.lockout.yes' | translate }}
                </button>
                <button slot="footer" class="button is-success is-medium" @click="negativeAction">
                    {{ 'components.common.modals.lockout.no' | translate }}
                </button>
            </div>
        </section>
    </modal>
</template>

<script>
import Modal from '../modal.vue';

export default {
    name: 'lockout',
    props: ['isOpen', 'closeModal'],
    components: { Modal },
    methods: {
        negativeAction() {
            this.$props.closeModal();
            this.emitUserExclude(false);
        },
        positiveAction() {
            this.$props.closeModal();
            this.emitUserExclude(true);
        },
        emitUserExclude(value) {
            this.$emit('userExclude', value);
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/modals/lockout/lockout.vue